import script from "./MetaverseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MetaverseView.vue?vue&type=script&lang=ts&setup=true"

import "./MetaverseView.vue?vue&type=style&index=0&id=1a22c604&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a22c604"]])

export default __exports__